<mat-sidenav-container class="sidebar-container" [hasBackdrop]="showMask()" [ngStyle]="styles()" [ngClass]="styleClass()">
  <mat-sidenav #sidenav [mode]="'over'" [position]="position()" [opened]="visibleValue">
    <div class="drawer-header" *ngIf="header()">
      <ng-container [ngTemplateOutlet]="header()"></ng-container>
    </div>

    <div class="drawer-content" *ngIf="content()">
      <ng-container [ngTemplateOutlet]="content()"></ng-container>
    </div>

    <div class="drawer-footer" *ngIf="footer()">
      <ng-container [ngTemplateOutlet]="footer()"></ng-container>
    </div>
  </mat-sidenav>
</mat-sidenav-container>
